import loadGoogleMapsApi from "load-google-maps-api";

const INPOST = 2;
const RUCH = 3;
const DHL = 38;
const INPOST_ICON = "/img/inpostPin.png";
const RUCH_ICON = "/img/pwrPin.png";
const DHL_ICON = "/img/dhlPin.png";
const INPOST_DATA = "/data/inpostData.json";
const RUCH_DATA = "/data/pwrData.json";
const DHL_DATA = "/data/dhlData.json";

let inpostInitialized = false;
let ruchInitialized = false;
let dhlInitialized = false;
let googleMaps;
let infoWindow;
let map = null;
let requestSent = false;
let modalBody = null;
let lastType = '';
let lastMarker = null;

function bind() {
    const mapModals = $('[data-map-modal]');
    mapModals.on('show.bs.modal', function (e) {
        mapInit($(this));
    });
    mapModals.on('shown.bs.modal', function (e) {
        loadMarkers($(this));
    });
    mapModals.on('hide.bs.modal', function (e) {
        allowRequests($(this));
    });
}

function mapInit(modal) {
    modal.find('.map-loading').removeClass('d-none');
    if (map == null) {
        loadGoogleMapsApi({
            language: 'pl',
            key: 'AIzaSyDG9tIq7PyV4ha7GJCSwoEhJKxp9CbLNkQ',
            libraries: ['places'],
        }).then(function (api) {
            googleMaps = api;
            newMap(modal);
        });
    } else {
        let currBody = modal.find('.modal-body');
        if (currBody.length <= 0) {
            modal.find('.modal-content').append($('<div class="modal-body"></div>'));
            currBody = modal.find('.modal-body');
        }
        modalBody = currBody.replaceWith(modalBody);
    }
}

function newMap(modal) {
    const args = {
        zoom: 6,
        center: new googleMaps.LatLng(51.9189046, 19.1343786),
        mapTypeId: googleMaps.MapTypeId.ROADMAP,
        scrollwheel: true,
        mapTypeControl: false,
        streetViewControl: false,
        rotateControl: false,
    };
    map = new googleMaps.Map(modal.find('.map')[0], args);

    infoWindow = new googleMaps.InfoWindow();
    googleMaps.event.addListener(infoWindow, 'domready', function () {
        $('#infoWindowButton').on('click', function (e) {
            if (requestSent) {
                return;
            }
            requestSent = true;
            const modalWindow = $(this).closest('.modal');
            modalWindow.find('.map-loading').removeClass('d-none');
            const $form = modalWindow.find('form');
            if (lastMarker.data('zip') === "") {
                $form.find('[name="zip"]').val("00-000");
            } else {
                $form.find('[name="zip"]').val(lastMarker.data('zip'));
            }
            if (lastMarker.data('building') === "") {
                $form.find('[name="building"]').val("0");
            } else {
                $form.find('[name="building"]').val(lastMarker.data('building'));
            }

            $form.find('[name="nameAddress"]').val(lastMarker.data('title'));
            $form.find('[name="city"]').val(lastMarker.data('city'));
            $form.find('[name="flat"]').val(lastMarker.data('flat'));
            $form.find('[name="street"]').val(lastMarker.data('street'));
            $form.find('[name="psd"]').val(lastMarker.data('psd'));
            $form.trigger('submit');
        });
    });

    addButtons();

    map.clusterer = new MarkerClusterer(map, [], {
        imagePath: "/libraries/@googlemaps/markerclustererplus/images/m",
        maxZoom: 15,
    });

    map.markers = [];
    map.currentMarkers = [];

    map.addListener('idle', () => {
        refreshMarkers();
    });

    initAutocomplete(modal);
}

function loadMarkers(modal) {
    const type = modal.data('map-modal');
    const $loading = modal.find('.map-loading');
    modalBody = modal.find('.modal-body');
    if (type === INPOST) {
        if (!inpostInitialized) {
            inpostInitialized = true;
            $.getJSON(INPOST_DATA, function (json) {
                map.response = json;
                centerMap();
                addMarkers(type, $loading);
            });
        } else {
            setMarkers(type, $loading);
            if (lastType !== type) {
                centerMap();
                refreshMarkers();
            }
        }
    } else if (type === RUCH) {
        if (!ruchInitialized) {
            ruchInitialized = true;
            $.getJSON(RUCH_DATA, function (json) {
                map.response = json;
                centerMap();
                addMarkers(type, $loading);
            });
        } else {
            setMarkers(type, $loading);
            if (lastType !== type) {
                centerMap();
                refreshMarkers();
            }
        }
    } else if (type === DHL) {
        if (!dhlInitialized) {
            dhlInitialized = true;
            $loading.addClass('d-none');
            $.getJSON(DHL_DATA, function (json) {
                map.response = json;
                centerMap();
                addMarkers(type, $loading);
            });
        } else {
            setMarkers(type, $loading);
            if (lastType !== type) {
                centerMap();
                refreshMarkers();
            }
        }
    }
    lastType = type;
}

function initAutocomplete(modal) {
    const input = modal.find('.search-bar-map');
    const searchBox = new googleMaps.places.SearchBox(input[0]);
    map.addListener("bounds_changed", () => {
        searchBox.setBounds(map.getBounds());
    });
    map.searchMarkers = [];
    searchBox.addListener("places_changed", () => {
        const places = searchBox.getPlaces();

        if (places.length === 0) {
            return;
        }
        map.searchMarkers.forEach((marker) => {
            marker.setMap(null);
        });
        map.searchMarkers = [];
        const bounds = new google.maps.LatLngBounds();
        places.forEach((place) => {
            if (!place.geometry || !place.geometry.location) {
                return;
            }
            const icon = {
                url: "https://maps.gstatic.com/mapfiles/place_api/icons/v1/png_71/geocode-71.png",
                size: new google.maps.Size(71, 71),
                origin: new google.maps.Point(0, 0),
                anchor: new google.maps.Point(17, 34),
                scaledSize: new google.maps.Size(25, 25),
            };
            map.searchMarkers.push(
                new google.maps.Marker({
                    map,
                    icon,
                    title: place.name,
                    position: place.geometry.location,
                })
            );

            if (place.geometry.viewport) {
                bounds.union(place.geometry.viewport);
            } else {
                bounds.extend(place.geometry.location);
            }
        });
        map.fitBounds(bounds);
    });
}

function addButtons() {
    const locationButton = document.createElement("button");
    locationButton.textContent;
    locationButton.classList.add("google-map-button");
    const locationIcon = document.createElement("i");
    locationIcon.className = 'fa-solid fa-map-marker-alt';
    locationButton.appendChild(locationIcon);
    map.controls[googleMaps.ControlPosition.RIGHT_BOTTOM].push(locationButton);
    locationButton.addEventListener("click", () => {
        centerMap(false);
    });
}

function refreshMarkers() {
    map.clusterer.clearMarkers();
    map.clusterer.addMarkers(map.currentMarkers = map.markers.filter(marker => marker.getVisible() && map.getBounds().contains(marker.getPosition())));
}

function addMarkers(type, $loading) {
    let x = 0, l = map.response.length;
    map.markers = [];
    let iconUri = '';
    if (type === INPOST) {
        iconUri = INPOST_ICON;
    } else if (type === RUCH) {
        iconUri = RUCH_ICON;
    } else if (type === DHL) {
        iconUri = DHL_ICON;
    }
    while (x < l) {
        const marker = new googleMaps.Marker({
            position: new googleMaps.LatLng(map.response[x].latitude, map.response[x].longitude),
            icon: iconUri,
            title: map.response[x].name,
        });
        const $marker = $(marker);
        $marker.data('title', map.response[x].name);
        $marker.data('psd', map.response[x].psd);
        $marker.data('street', map.response[x].street);
        if (map.response[x].building_number === null) {
            $marker.data('building', '');
        } else {
            $marker.data('building', map.response[x].building_number);
        }
        if (map.response[x].flat_number === null) {
            $marker.data('flat', '');
        } else {
            $marker.data('flat', '/' + map.response[x].flat_number);
        }
        if (map.response[x].post_code === null) {
            $marker.data('zip', '');
        } else {
            $marker.data('zip', map.response[x].post_code);
        }
        if (map.response[x].location_description === null) {
            $marker.data('description', '');
        } else {
            $marker.data('description', map.response[x].location_description);
        }
        $marker.data('city', map.response[x].city);
        $marker.data('hours', map.response[x].opening_hours);
        googleMaps.event.addListener(marker, 'click', function () {
            let title = '';
            if (type === INPOST) {
                title = "Paczkomat Inpost";
            } else if (type === RUCH) {
                title = "ORLEN paczka";
            } else if (type === DHL) {
                title = "Punkt DHL";
            }
            lastMarker = $marker;
            infoWindow.setContent(
                '<div class="text-center text-black">' +
                '<h4>' + title + '</h4>' +
                $marker.data('title') +
                '<br/><br/>' +
                $marker.data('street') + ' ' + $marker.data('building') + $marker.data('flat') +
                '<br/>' +
                $marker.data('zip') + ' ' + $marker.data('city') +
                '<br/>' +
                $marker.data('description') +
                '<br/><br/>' +
                'Dostępny: ' + $marker.data('hours').replace("So:", "<br/>So:") +
                '<br/>' +
                '<div class="border-top mt-2"><button id="infoWindowButton" class="btn btn-cyan button-info-window mt-2">Wybierz</button></div>' +
                '</div>');
            infoWindow.open(map, marker);
        });
        map.markers.push(marker);
        ++x;
    }
    refreshMarkers();
    if (type === INPOST) {
        map.inpostMarkers = map.markers;
    } else if (type === RUCH) {
        map.ruchMarkers = map.markers;
    } else if (type === DHL) {
        map.dhlMarkers = map.markers;
    }
    $loading.addClass('d-none');
}

function setMarkers(type, $loading) {
    if (type === INPOST) {
        map.markers = map.inpostMarkers;
    } else if (type === RUCH) {
        map.markers = map.ruchMarkers;
    } else if (type === DHL) {
        map.markers = map.dhlMarkers;
    }
    $loading.addClass('d-none');
}

function centerMap(forced = true) {
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
            (position) => {
                const pos = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude,
                };
                map.zoom = 14;
                map.setCenter(pos);
            },
            () => {
                if (forced) {
                    handleLocationError(map);
                } else {
                    infoWindow.setPosition(map.getCenter());
                    infoWindow.setContent('Nie udało się ustalić lokalizacji');
                    infoWindow.open(map);
                }
            }
        );
    } else {
        // Browser doesn't support Geolocation
        if (forced) {
            handleLocationError(map);
        } else {
            infoWindow.setPosition(map.getCenter());
            infoWindow.setContent('Przeglądarka nie wspiera geolokalizacji');
            infoWindow.open(map);
        }
    }
}

function handleLocationError() {
    map.setCenter({lat: 51.9189046, lng: 19.1343786});
    map.setZoom(6);
}

function allowRequests() {
    requestSent = false;
}

export {
    mapInit,
    loadMarkers,
    allowRequests,
    bind,
}
